import React from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";

export default function SkillRadarChart({ skills }) {
  const hasSignal = skills?.some((s) => s.score > 0);
  return (
    <div data-testid="portfolio-skill-radar-chart">
      {!hasSignal && <p className="text-xs text-slate-400 text-center mb-2">Complete simulations, case studies, and SQL tasks to populate the skill radar.</p>}
      <ResponsiveContainer width="100%" height={320}>
        <RadarChart data={skills} outerRadius="75%">
          <PolarGrid stroke="rgba(255,255,255,0.1)" />
          <PolarAngleAxis dataKey="skill" tick={{ fill: "#94a3b8", fontSize: 11 }} />
          <PolarRadiusAxis angle={90} domain={[0, 100]} tick={false} axisLine={false} />
          <Radar name="Skill Score" dataKey="score" stroke="#6366F1" fill="#6366F1" fillOpacity={0.25} strokeWidth={2} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
